module.exports = __webpack_public_path__ + "static/JL.190207.COH.WEBW.Gallery7-cd2b8410879a75a148c6d5b2023b97f4.jpg";